import { render, staticRenderFns } from "./RequestForMaterialItem.vue?vue&type=template&id=e0d959d0&"
import script from "./RequestForMaterialItem.vue?vue&type=script&lang=js&"
export * from "./RequestForMaterialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports